document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("click", function (e) {
    if (e.target.closest(".cart-attribute__field")) {
      var formData = new FormData();
      var attributeValue = document.querySelector(".cart-attribute__field input:checked").getAttribute("value");
      formData.append("attributes[Responsible packaging]", attributeValue);
      
      fetch('https://www.inarijewellery.com/cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json());
    }
  })
});
